
/**
 * DEVELOPER DOCUMENTATION
 * [既存のドキュメントは省略]
 */

// 名前空間を使用してグローバル汚染を防ぐ
const ThemeCustomizations = (function() {
  'use strict';
  
  // 定数の定義
  const DELAYS = {
    URL_CHECK: 400,
    RADIO_SELECT: 500,
    TAX_CALCULATION: 4300
  };
  
  // 状態管理
  let currentUrl = location.href;
  
  // ユーティリティ関数
  const utils = {
    // 価格を1.1倍（税込）に変換
    calculateTaxIncludedPrice: function(priceText) {
      const numericPrice = priceText.slice(1).replace(/,/g, '');
      const taxIncluded = numericPrice * 1.1;
      return '¥' + String(taxIncluded).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    },
    
    // ラジオボタンの最初の有効な要素を選択
    selectFirstRadio: function(selector) {
      $(selector).each(function() {
        // disabledでない最初のラジオボタンを探す
        const $availableRadio = $(this).find('input[type="radio"]:not(:disabled)').first();
        if ($availableRadio.length > 0) {
          $availableRadio.prop('checked', true);
        }
      });
    },
    
    // 売り切れでない最初のオプションを選択
    selectFirstAvailableOption: function(containerSelector) {
      const $container = $(containerSelector);
      const $availableOptions = $container.find('.y-swatch-wrap:not(.is-disabled)');
      
      if ($availableOptions.length > 0) {
        // 利用可能なオプションがある場合
        $availableOptions.first().find('input[type="radio"]').prop('checked', true);
      } else {
        // 全て売り切れの場合の処理
        console.warn('All options are sold out for:', containerSelector);
        
        // 売り切れメッセージを表示
        if (!$container.find('.all-sold-out-message').length) {
          $container.append('<div class="all-sold-out-message">申し訳ございません。現在全ての味が売り切れです。</div>');
        }
        
        // 親要素に売り切れクラスを追加
        $container.addClass('all-options-sold-out');
        
        // カートボタンを無効化
        const $form = $container.closest('form');
        if ($form.length) {
          $form.find('#AddToCart').prop('disabled', true).text('売り切れ');
        }
      }
      
      return $availableOptions.length > 0;
    }
  };
  
  // 機能モジュール
  const modules = {
    // URL変更の監視とラジオボタンのリセット
    urlChangeHandler: function() {
      $(document).on('change', '.set-list input', function() {
        setTimeout(function() {
          console.log('Current URL:', currentUrl);
          if (currentUrl !== location.href) {
            $('#query input[type="radio"]').prop('checked', false);
            currentUrl = location.href;
            console.log("fire")
          }
          // 売り切れでない最初のオプションを選択
          $('.shown').each(function() {
            utils.selectFirstAvailableOption($(this).find('.flavor-list'));
          });
          $('.shown2').each(function() {
            utils.selectFirstAvailableOption($(this).find('.flavor-list'));
          });
        }, DELAYS.URL_CHECK);
      });
    },
    
    // セット2の表示/非表示制御
    set2Handler: function() {
      const toggleSet2 = function() {
        if ($('.set-2 input[type="radio"]').is(':checked')) {
          $(".f-2").addClass("shown");
          setTimeout(function() {
            utils.selectFirstRadio('.shown');
          }, DELAYS.RADIO_SELECT);
        } else {
          $(".f-2").removeClass("shown");
        }
      };
      
      // 初期化時とchange時の両方で実行
      toggleSet2();
      $(document).on("change", ".set-list input", toggleSet2);
    },
    
    // セット3の表示/非表示制御
    set3Handler: function() {
      const toggleSet3 = function() {
        if ($('.set-3 input[type="radio"]').is(':checked')) {
          $(".f-3").addClass("shown2");
          setTimeout(function() {
            utils.selectFirstRadio('.shown2');
          }, DELAYS.RADIO_SELECT);
        } else {
          $(".f-3").removeClass("shown2");
        }
      };
      
      // 初期化時とchange時の両方で実行
      toggleSet3();
      $(document).on("change", ".set-list input", toggleSet3);
    },
    
    // アコーディオン機能
    accordionHandler: function() {
      $('.js-accordion-title').on('click', function() {
        $(this).next().slideToggle(400);
        $(this).toggleClass('open', 400);
      });
      
      $('.accordion-title').on('click', function() {
        const $this = $(this);
        if ($this.hasClass('xoss')) {
          $this.delay(400).queue(function() {
            $this.removeClass('xoss').dequeue();
          });
        } else {
          $this.addClass('xoss');
        }
      });
    },
    
    // ギフト選択の制御
    giftSelectionHandler: function() {
      // 初期設定
      setTimeout(function() {
        $(".final-gift-1 label").trigger('click');
        $(".beauty").hide();
        // 売り切れでない最初のオプションを選択
        utils.selectFirstAvailableOption('.flavor-list');
      }, DELAYS.RADIO_SELECT);
      
      // ギフト1選択時
      $('.final-gift-1 label').on('click', function() {
        $(".beauty").hide();
        $(".diet").show();
      });
      
      // ギフト2選択時
      $('.final-gift-2 label').on('click', function() {
        $(".beauty").show();
        $(".diet").hide();
      });
      
      // セレクトボックスの変更時
      $('select').on('change', function() {
        const selectedValue = $(this).val();
        if (selectedValue.indexOf("NORMビューティー") > -1) {
          $(".beauty").show();
          $(".diet").hide();
        } else if (selectedValue.indexOf("NORMダイエット") > -1) {
          $(".beauty").hide();
          $(".diet").show();
        }
      });
    },
    
    // 税込価格の計算と表示
    taxCalculationHandler: function() {
      setTimeout(function() {
        $('.10tax').each(function() {
          const $this = $(this);
          const originalPrice = $this.find(".secondPrice").text();
          const taxIncludedPrice = utils.calculateTaxIncludedPrice(originalPrice);
          $this.find(".firstPriceValue").text(taxIncludedPrice);
          console.log('Tax included price:', taxIncludedPrice);
        });
      }, DELAYS.TAX_CALCULATION);
    },
    
    // 売り切れ商品の処理
    soldOutHandler: function() {
      // バリアント変更時の売り切れチェック
      document.addEventListener('variant:changed', function(event) {
        const variant = event.detail.variant;
        const form = event.target;
        
        if (!variant.available) {
          // 売り切れの場合
          form.querySelector('.product-form__submit').disabled = true;
          form.querySelector('.product-form__submit').textContent = '売り切れ';
          form.classList.add('product-form--sold-out');
        } else {
          // 在庫ありの場合
          form.querySelector('.product-form__submit').disabled = false;
          form.querySelector('.product-form__submit').textContent = 'カートに追加';
          form.classList.remove('product-form--sold-out');
        }
      });
      
      // ページ読み込み時の売り切れチェック
      $('.product-form').each(function() {
        const $form = $(this);
        const selectedVariant = $form.find('input[name="id"]:checked, select[name="id"]').val();
        
        // ShopifyのAPIを使って在庫状態をチェック（要実装）
        // checkVariantAvailability(selectedVariant, $form);
      });
      
      // セット商品の売り切れチェック
      $(document).on('change', '.set-list input', function() {
        const $this = $(this);
        const variantId = $this.val();
        
        // 売り切れ商品の無効化
        if ($this.data('available') === false) {
          $this.prop('disabled', true);
          $this.closest('label').addClass('sold-out');
        }
        
        // セット選択後の各フレーバー選択も売り切れチェック
        setTimeout(function() {
          $('.shown .flavor-list, .shown2 .flavor-list').each(function() {
            const hasAvailable = utils.selectFirstAvailableOption($(this));
            if (!hasAvailable) {
              console.warn('No available options in set');
            }
          });
        }, DELAYS.RADIO_SELECT);
      });
    }
  };
  
  // 初期化関数
  const init = function() {
    console.log('Theme customizations initializing...');
    console.log('Initial URL:', currentUrl);
    
    // 各モジュールの初期化
    modules.urlChangeHandler();
    modules.set2Handler();
    modules.set3Handler();
    modules.accordionHandler();
    modules.giftSelectionHandler();
    modules.taxCalculationHandler();
    modules.soldOutHandler();
    
    console.log('Theme customizations initialized.');
  };
  
  // DOMContentLoadedで初期化
  $(document).ready(init);
  
  // パブリックAPIを返す
  return {
    init: init,
    utils: utils
  };
})();